export const getAppStyle = function () {
  // return 1
  // 获取环境状态 -1: pc, 0: h5, 1: ios, 2: android
  let result = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 0 : -1;
  let isInIosApp = window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getUserInfo
  let isInAndroidApp = window.thepaper && window.thepaper.getUserInfo
  if (isInIosApp) { // in ios
    result = 1
  } else if (isInAndroidApp) { //in android
    result = 2
  }
  return result
}

export const goLink = function (link) {
  console.log('goLink link :>> ', link);
  const c = getAppStyle();
  // 判断是站内还是站外
  if (c > 0) {
    // 是否是app站内链接
    if (link?.app?.contId) {
      if (!link?.app?.links) {
        THEPAPER.api.goApp(
          link?.app?.forwardType ? link?.app?.forwardType?.toString() : '',
          link?.app?.contId ? link?.app?.contId?.toString() : ''
        );
      } else {
        window.location.href = link?.app?.links;
      }

    } else {
      // 拥有跳转链接
      if (link?.web) {
        window.location.href = link?.web;
      }
    }
  } else {
    // wap、www
    if (link?.web) {
      window.location.href = link?.web;
    }
  }
}


export default goLink;